/*@flow*/
import getBboxCenter from 'lib/getBboxCenter';
import getBboxFromQuery from 'lib/getBboxFromQuery';
import * as db from 'lib/db';

function getCenterFromQuery() {
  const bboxString = getBboxFromQuery();
  return getBboxCenter(bboxString);
}

export default (): void | Array<any> | Array<number> => {
  const bboxCenter = getCenterFromQuery();
  if (bboxCenter) return bboxCenter;

  const defaultView = db.read('bbox');
  if (!defaultView) return [40.712654662428214, -74.00588035583496];

  return getBboxCenter(defaultView);
};
